import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your translation files for new languages
import translationFR from './locales/fr/translation.json';
import translationNL from './locales/nl/translation.json';


// the translations
const resources = {
	'fr': {
	  translation: translationFR,
	},
	'fr-BE': {
	  translation: translationFR,
	},
	'fr-FR': {
		translation: translationFR,
	},
	'nl': {
	  translation: translationNL,
	},
    'nl-BE': {
		translation: translationNL,
	},
};

// Assuming you have a way to dynamically determine these values at startup
// For example, from environment variables, user preferences, etc.
const defaultLanguage = 'fr'; // This should be dynamically determined
const fallbackLanguage = 'fr'; // This should be dynamically determined
  

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage,
    fallbackLng: fallbackLanguage,

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },

	// Enable fallback for empty strings
	returnEmptyString: false,
  });

export default i18n;